import { FC } from 'react';
import { DataCategory } from '../subheader-category-items/types';
import { CatHeading } from '@blocks-react/components/Heading';
import { CatGrid } from '@blocks-react/components/Grid';
import { CatGridItem } from '@blocks-react/components/GridItem';
import { CatList } from '@blocks-react/components/List';
import { CatListItem } from '@blocks-react/components/ListItem';
import styles from '../subheader-category-items/style.module.scss';
import cx from 'classnames';
import { MAIN_NAV_TRACK } from '../../../../constants/analyticsConstants';

interface CategoryItemsDesktopProps {
  label: string;
  categories: DataCategory[];
  divider?: boolean;
}

export const SubheaderCategoryItemsDesktop: FC<CategoryItemsDesktopProps> = ({
  label,
  divider = false,
  categories,
}) => {
  return (
    <>
      <div className="mb-4 ms-2">
        <CatHeading
          decorator
          variant="title-sm"
          data-track-event={MAIN_NAV_TRACK.EVENT}
          data-track-attr-nltext={label}
          data-track-attr-context={MAIN_NAV_TRACK.TOP_SUBMENU_CONTEXT}
        >
          {label}
        </CatHeading>
      </div>
      <CatGrid variant="1-3up" gap="none">
        {categories.map(({ key, data }) => {
          return (
            <CatGridItem key={key}>
              <CatList className={styles['c-top-nav__list']}>
                {data.map(({ name, seoURL, isActive = false }) => (
                  <CatListItem
                    className={cx(styles['c-top-nav__list-item'], {
                      [styles['c-top-nav__list-item--bg']]: isActive,
                    })}
                    key={name}
                    href={seoURL}
                    styleModifier={'cat-u-padding-none'}
                    data-testid="category-list-item"
                    data-track-event={MAIN_NAV_TRACK.EVENT}
                    data-track-attr-nltext={name}
                    data-track-attr-context={MAIN_NAV_TRACK.TOP_SUBMENU_CONTEXT}
                  >
                    {name}
                  </CatListItem>
                ))}
              </CatList>
            </CatGridItem>
          );
        })}
      </CatGrid>
      {divider && <hr className={styles['category--divider']} />}
    </>
  );
};
